import React from 'react';
import PropTypes from 'prop-types';
import { constant, mapObject } from 'underscore';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import ImportTypeItem from './import-type-item';
import { getMenuItemListStyles } from '../styles/menu-item-styles';

class ImportTypeItemList extends React.PureComponent {
  render() {
    const {
      classes,
      items,
      isExpanded,
      onMenuItemClick,
      classList,
    } = this.props;

    const cnames = classNames(['main-menu-link-list', classes.menuList, ...classList]);

    return (
      <div className={cnames}>{
        isExpanded &&
        <div >
          {items.map(item =>
          (
            <ImportTypeItem
              key={item.Id}
              node={item}
              renderText={isExpanded ? item.Name : null}
              onItemClick={onMenuItemClick}
            />
          ))}
        </div>
      }
      </div>
    );
  }
}

ImportTypeItemList.propTypes = {
  classes: PropTypes.shape(mapObject(
    getMenuItemListStyles(),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  classList: PropTypes.arrayOf(PropTypes.string),
  isExpanded: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.string,
    Name: PropTypes.string.isRequired,
  })),
  onMenuItemClick: PropTypes.func.isRequired,
};

ImportTypeItemList.defaultProps = {
  items: [],
  classList: [],
};

export const StyledImportTypeItemList = withDefaultStyles(ImportTypeItemList, getMenuItemListStyles);
